module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "problem-list"
  }, _vm._l((_vm.compProblems), function(problem, index) {
    return _c('li', {
      key: problem.id
    }, [_c('div', [_c('label', {
      on: {
        "dblclick": function($event) {
          _vm.edit(problem, index)
        }
      }
    }, [_vm._v("\n        " + _vm._s(index) + " - " + _vm._s(problem.name) + "\n      ")]), _vm._v("\n      @ "), _c('a', {
      attrs: {
        "href": problem.url
      }
    }, [_vm._v(" judge ")]), _vm._v(" "), _c('button', {
      staticClass: "destroy",
      on: {
        "click": function($event) {
          _vm.removeProblem(problem, index)
        }
      }
    }, [_vm._v("\n        x\n      ")]), _vm._v(" "), _c('pre', {
      domProps: {
        "innerHTML": _vm._s(problem.notes)
      }
    })])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b1fa4470!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProblemList.vue
// module id = 54
// module chunks = 2